import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = { class: "main-layout__content" }

import AsidePanel from "@/components/layout/AsidePanel.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AsidePanel),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterView)
    ])
  ]))
}
}

})